import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
import { useOrder } from '../context/OrderContext';
import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
export const OrderBar = () => {
  const {
    cartCount,
    cartTotal
  } = useOrder();
  const {
    t
  } = useLanguage();
  const navigate = useNavigate();
  return <AnimatePresence data-id="element-35">
      {cartCount > 0 && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-50 flex justify-center pb-6 pt-4 px-4 bg-gradient-to-t from-cream via-cream to-transparent pointer-events-none" data-id="element-36">
          <div className="w-full max-w-md pointer-events-auto" data-id="element-37">
            <button onClick={() => navigate('/cart')} className="w-full bg-terracotta hover:bg-terracotta-dark text-white shadow-up rounded-2xl p-4 flex items-center justify-between transition-colors active:scale-[0.98]" data-id="element-38">
              <div className="flex items-center gap-3" data-id="element-39">
                <div className="bg-white/20 rounded-full w-8 h-8 flex items-center justify-center relative" data-id="element-40">
                  <ShoppingBag size={16} strokeWidth={2.5} data-id="element-41" />
                </div>
                <span className="font-medium" data-id="element-42">{t('orderbar.review')}</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-43">
                <span className="text-sm font-medium bg-white/20 px-2.5 py-1 rounded-full" data-id="element-44">
                  {cartCount}{' '}
                  {cartCount === 1 ? t('orderbar.item') : t('orderbar.items')}
                </span>
                <span className="font-serif text-lg" data-id="element-45">{cartTotal} kr</span>
              </div>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};